module.exports = __webpack_public_path__ + "img/welding.7d69ed48.jpg";